export const formatMaterialCount = (count: string, measure: string) => {
    const value = Number(count)
    if (!value || isNaN(value)) return ""
    if (measure.toLowerCase().includes("шт")) {
        return String(Math.ceil(value))
    }
    return String(value.toFixed(2))
}